import { useEventListener } from './useEventListener';

export const useTogglePopover = (
  togglerRef,
  popoverRef,
  popOverStateToggler,
) => {
  const onClickhandler = (event) => {
    if (!togglerRef?.current || !popoverRef?.current) {
      return;
    }

    const isInsidePopOver = popoverRef?.current?.contains?.(event?.target);
    const isInsideToggler = togglerRef?.current?.contains?.(event?.target);
    const isTogglerClicked = !isInsidePopOver && isInsideToggler;
    const isPopoverClicked = isInsidePopOver && isInsideToggler;
    const isClickedOutside = !isInsidePopOver && !isInsideToggler;

    if (isPopoverClicked) {
      return;
    }

    if (isTogglerClicked) {
      popOverStateToggler?.();
      return;
    }

    if (isClickedOutside) {
      popOverStateToggler?.(false);
    }
  };

  useEventListener('click', onClickhandler, document);
};
